import type { Route } from '!/router'
import { keys } from '~/shared/jail'
import { Footer } from '~/shared/ui/components/Footer'
import { NavBar } from '~/widgets/NavBar'
import { PolicyMessageAuth } from '~/features/policy-message'
import * as expired from '~/routes/auth/expired'
import * as fail from '~/routes/auth/fail'
import * as geoblock from '~/routes/auth/geoblock'
import * as logout from '~/routes/auth/logout'
import * as signin from '~/routes/auth/sign-in'
import * as toa from '~/routes/auth/toa'
import * as verify from '~/routes/auth/verify'

import * as signUpRoot from '~/routes/auth/sign-up/_'
import * as signUpDone from '~/routes/auth/sign-up/done'
import * as signUpFail from '~/routes/auth/sign-up/fail'

import * as forgotPasswordRoot from '~/routes/auth/forgot-password/_'
import * as forgotPasswordDone from '~/routes/auth/forgot-password/done'
import * as forgotPasswordFail from '~/routes/auth/forgot-password/fail'
import * as forgotPasswordNew from '~/routes/auth/forgot-password/new'
import * as forgotPasswordVerify from '~/routes/auth/forgot-password/verify'

export const route: Route = {
  keys: [keys.sign, keys.guest],

  children: [
    {
      path: ['/sign-in/verify', '/sign-up/verify'],
      init: verify.authVerifyModel.init,
      component: [verify.Title, verify.VerifyPage, PolicyMessageAuth],
    },
    {
      path: '/sign-in{/*path}',
      init: signin.model.init,
      left: signin.model.left,
      component: [signin.Title, signin.SignInPage, PolicyMessageAuth],
    },
    {
      keys: [keys.toa],
      path: '/toa{/*path}',
      init: toa.model.init,
      component: [toa.Title, toa.ToaPage, PolicyMessageAuth],
    },
    {
      keys: [keys.expired],
      path: '/expired{/*path}',
      component: [
        expired.Title,
        expired.ExpiredPage,
        Footer,
        PolicyMessageAuth,
      ],
      init: expired.model.init,
    },
    {
      keys: [keys.master],
      path: '/logout{/*path}',
      component: [
        logout.Title,
        NavBar,
        logout.LogoutPage,
        Footer,
        PolicyMessageAuth,
      ],
      init: logout.model.init,
      left: logout.model.left,
    },
    {
      path: '/sign-up',
      children: [
        {
          path: '',
          init: signUpRoot.model.init,
          left: signUpRoot.model.left,
          component: [
            signUpRoot.Title,
            signUpRoot.SignUpPage,
            PolicyMessageAuth,
          ],
        },
        {
          path: '/done',
          component: [signUpDone.Title, signUpDone.DonePage],
        },
        {
          path: '/fail',
          component: [signUpFail.Title, signUpFail.FailPage],
        },
      ],
    },
    {
      path: '/forgot-password',
      children: [
        {
          path: '',
          init: forgotPasswordRoot.model.init,
          component: [
            forgotPasswordRoot.Title,
            forgotPasswordRoot.ForgotPasswordPage,
            PolicyMessageAuth,
          ],
        },
        {
          path: '/verify',
          init: forgotPasswordVerify.model.init,
          component: [
            forgotPasswordVerify.Title,
            forgotPasswordVerify.VerifyPage,
            PolicyMessageAuth,
          ],
        },
        {
          path: '/new',
          init: forgotPasswordNew.model.init,
          component: [
            forgotPasswordNew.Title,
            forgotPasswordNew.NewPasswordPage,
            PolicyMessageAuth,
          ],
        },
        {
          path: '/done',
          component: [forgotPasswordDone.Title, forgotPasswordDone.DonePage],
        },
        {
          path: '/fail',
          component: [forgotPasswordFail.Title, forgotPasswordFail.FailPage],
        },
      ],
    },
    {
      path: '/fail',
      component: [fail.Title, fail.ErrorPage],
    },
    {
      keys: [keys.geoblock],
      path: '/geoblock',
      component: [geoblock.Title, geoblock.GeoBlockPage],
    },
  ],
}
